const middleware = {}

middleware['add-trailing-slash'] = require('../../middleware/add-trailing-slash.js')
middleware['add-trailing-slash'] = middleware['add-trailing-slash'].default || middleware['add-trailing-slash']

middleware['internal-redirect'] = require('../../middleware/internal-redirect.js')
middleware['internal-redirect'] = middleware['internal-redirect'].default || middleware['internal-redirect']

export default middleware
